import {Radio as GfiberRadio, type RadioProps} from '@pixel-party/Radio/v2';
import {forwardRef} from 'react';

export const Radio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  return (
    <GfiberRadio
      {...props}
      ref={ref}
    />
  );
});

Radio.displayName = 'Radio';
